import React from 'react';
import ReadingPageLayout from '../components/reading-page-layout';
import readingcomp from '../Data/readingcomp.jsx';

const readingData = readingcomp.find(r => r.id === 'reading-self-sevice-society');

const ReadingSelfSeviceSociety = () => (
  <ReadingPageLayout
    level={readingData.level}
    title={readingData.readingcompTitle}
    image={readingData.image}
    readingData={readingData}
    seoTitle={`Free English Reading: ${readingData.readingcompTitle}`}
    seoDescription={readingData.description}
    relatedCategory="reading-exercises"
    relatedLevel={readingData.level}
  />
);

export default ReadingSelfSeviceSociety;
